import { get } from "lodash";
import { bool, func, object } from "prop-types";
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { AD_LIMIT, TABOOLA_WIDGET_POSITION, TEADS_AD_POSITION } from "../../constants";
import { isAdPosition, isAdPositionWithTaboola } from "../utils/story";
import { getQueryParamsForArticleApi } from "../utils/utils";
import AdWrapper from "./atoms/AdWrapper";

export const WithStoryAds = ({ counter = {}, componentToRender, story }) => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const currentPath = useSelector((state) => get(state, ["qt", "currentPath"], {}));

  const params = getQueryParamsForArticleApi(currentPath);

  const noAds = get(qtState, ["config", "noAds"], false);
  counter.paragraphs++;
  const showAd =
    counter.ads < AD_LIMIT ? (params.articleApi ? isAdPosition(counter) : isAdPositionWithTaboola(counter)) : false;
  if (showAd) {
    counter.ads++;
  }
  const adRef = useRef(null);
  let storyIndex;
  if (adRef.current) {
    const closestInfiniteScrollParent = adRef.current.closest("[data-infinite-scroll]");
    storyIndex = get(closestInfiniteScrollParent, ["dataset", "infiniteScroll"], 0);
  }
  let addivId = "display_in_article_" + counter.ads;
  if (params.articleApi) {
    addivId = "app_display_in_article_" + counter.ads;
  }
  if (counter.ads > 3) {
    if (params.articleApi) {
      addivId = "app_display_in_article_rest";
    } else {
      addivId = "display_in_article_rest";
    }
  }
  return (
    <div ref={adRef}>
      {componentToRender}
      {counter.paragraphs === TEADS_AD_POSITION && !noAds && <div id="teads-article-ad"></div>}
      {counter.paragraphs === TABOOLA_WIDGET_POSITION && !noAds && !params.articleApi && <div id="mid-article"></div>}
      {counter.paragraphs === TABOOLA_WIDGET_POSITION && !noAds && params.articleApi && (
        <div id="taboola-sponsored-mid-article"></div>
      )}

      {showAd && !noAds && storyIndex >= 0 && (
        <AdWrapper adStyleName="story-page-ad-slot" id={addivId} isLhsAd={true} count={counter.ads} />
      )}
    </div>
  );
};

WithStoryAds.propTypes = {
  counter: object,
  story: object,
  showAd: bool,
  isParagraph: bool,
  componentToRender: func,
};
